import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";
import { FaHandshake, FaRupeeSign, FaHeadset, FaUsers, FaMapMarkerAlt, FaBuilding } from "react-icons/fa";
import wcu from "../../images/wcu.jpg";
import "../../css/whychooseus.css"; // Ensure CSS file is included

const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stops observing after activation
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-choose-us">
       <div className="wcontainer">
        {/*<div className="wcu-content">
          <div className="wcu-left">
            <h2 className="section-title">Why Choose Us?</h2>
            <p className="wcu-description">
            We know real estate decisions are big. That’s why we make the process simple, stress-free, and personalized — with a local expert by your side, every step of the way. </p>
          </div>
          <div className="wcu-right">
            <div className="wcu-card">
              <FaHandshake className="wcu-icon" />
              <h3>Easy Consultation</h3>
              <p>We don’t just sell properties—we help you make the right choice. Our experts understand your needs and guide you with personalized solutions for buying, renting, or investing.</p>           </div>
            <div className="wcu-card">
              <FaRupeeSign className="wcu-icon" />
              <h3>Financial Assistance</h3>
              <p>From home loans to legal paperwork, we simplify the process. Our team ensures smooth approvals, tax guidance, and transparent financial support.</p>
            </div>
            <div className="wcu-card">
              <FaHeadset className="wcu-icon" />
              <h3>Sale Assistance</h3>
              <p>Our service goes beyond the sale. We assist with documentation, registration, and utility transfers—ensuring a hassle-free transition for you.</p>
            </div>
            <div className="wcu-image">
              <img src={wcu} alt="Why Choose Us" />
            </div>
          </div>
        </div> */}

        {/* Statistics Section */}
        <div className="wcu-stats" ref={statsRef}>
          <div className="stat-cardw">
            <FaUsers className="stat-icon" />
            <span>{isVisible ? <CountUp start={0} end={3845} duration={5} /> : 0}+</span> Properties listed
          </div>

          <div className="stat-cardw">
            <FaHandshake className="stat-icon" />
            <span>{isVisible ? <CountUp start={0} end={154} duration={5.5} /> : 0}+</span> Locations Covers
          </div>

          <div className="stat-cardw">
            <FaMapMarkerAlt className="stat-icon" />
            <span>{isVisible ? <CountUp start={0} end={489} duration={5} /> : 0}+</span> Expert Agents
          </div>

          <div className="stat-cardw">
            <FaBuilding className="stat-icon" />
            <span>{isVisible ? <CountUp start={0} end={2435} duration={5.5} /> : 0}+</span> Properties Sold
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
